import React, { useState } from "react";
import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to MapleMarket!");
      nav("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <Layout hideFooter>
      <section className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
        <Link to="/" className="block text-center mb-8">
          <span className="font-heading text-3xl">MapleMarket</span>
        </Link>
        <h1 className="font-heading text-4xl text-center mb-2">Join MapleMarket</h1>
        <p className="text-center text-[#5C5A56] text-sm mb-8">Create your free account in seconds</p>

        <form onSubmit={submit} className="space-y-4">
          <Field label="Full name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} testid="register-name" />
          <Field label="Email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} testid="register-email" />
          <Field label="Password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testid="register-password" />
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit">
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>

        <p className="text-center text-sm text-[#5C5A56] mt-6">
          Already have an account? <Link to="/login" className="text-[#702A32] hover:underline">Sign in</Link>
        </p>
      </section>
    </Layout>
  );
}

function Field({ label, type = "text", required, value, onChange, testid }) {
  return (
    <div>
      <label className="block text-sm font-medium mb-1.5">{label}</label>
      <input type={type} required={required} value={value} onChange={onChange} className="input-field" data-testid={testid} />
    </div>
  );
}
